import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  deleteAdminV1StoresStoreIdPagesId,
  getAdminV1StoresStoreIdPages,
  getAdminV1StoresStoreIdPagesId,
  patchAdminV1StoresStoreIdPagesId,
  postAdminV1StoresStoreIdPages,
  type GetAdminV1StoresStoreIdPages200,
  type Page,
  type PatchAdminV1StoresStoreIdPagesIdBody,
  type PostAdminV1StoresStoreIdPagesBody,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `q`, `sort`, the flat filter
 * params (`status=draft`, `template=faq,policy`, `updatedAt_gte=2026-09-01`), `cursor`, `limit`.
 */
export type PageListParams = ListParams;

/** Content pages of one store (about, FAQ, policies, size guide). */
export const pagesApi = {
  list: (storeId: string, params: PageListParams): Promise<GetAdminV1StoresStoreIdPages200> =>
    getAdminV1StoresStoreIdPages({ storeId }, params),
  get: (storeId: string, id: string): Promise<Page> =>
    getAdminV1StoresStoreIdPagesId({ storeId, id }),
  create: (storeId: string, body: PostAdminV1StoresStoreIdPagesBody): Promise<Page> =>
    postAdminV1StoresStoreIdPages({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdPagesIdBody,
  ): Promise<Page> => patchAdminV1StoresStoreIdPagesId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdPagesId({ storeId, id }),
};
